import { createContext, useContext } from 'react'

const WHEEL_DELTA_SCALE = [1, 16, 400] as const

export const normalizeWheelDelta = (delta: number, mode: number): number =>
  delta * (WHEEL_DELTA_SCALE[mode] ?? 1)

export const MarqueeWheelRootContext = createContext<HTMLElement | undefined>(
  undefined,
)

export const useMarqueeWheelRoot = () => useContext(MarqueeWheelRootContext)

export const forwardWheelToMarquee = (
  marqueeRoot: HTMLElement,
  event: WheelEvent,
): void => {
  marqueeRoot.dispatchEvent(
    new WheelEvent('wheel', {
      deltaX: event.deltaX,
      deltaY: event.deltaY,
      deltaMode: event.deltaMode,
      bubbles: true,
      cancelable: true,
    }),
  )
}
